import { Skeleton } from "@/components/ui/skeleton";

/** Grid of product card placeholders */
export const FeaturedProductsSkeleton = () => (
  <section className="py-16 px-4 md:px-8">
    <div className="max-w-7xl mx-auto space-y-8">
      <div className="text-center space-y-2">
        <Skeleton className="h-8 w-48 mx-auto" />
        <Skeleton className="h-4 w-64 mx-auto" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="aspect-[3/4] w-full rounded-md" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

/** Category cards placeholder */
export const CategoriesSkeleton = () => (
  <section className="py-16 px-4 md:px-8">
    <div className="max-w-7xl mx-auto space-y-8">
      <Skeleton className="h-8 w-40 mx-auto" />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square w-full rounded-md" />
        ))}
      </div>
    </div>
  </section>
);

/** Instagram feed placeholder */
export const InstagramFeedSkeleton = () => (
  <section className="py-16 px-4 md:px-8">
    <div className="max-w-7xl mx-auto space-y-8">
      <Skeleton className="h-6 w-36 mx-auto" />
      <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square w-full rounded-sm" />
        ))}
      </div>
    </div>
  </section>
);

/** Newsletter placeholder */
export const NewsletterSkeleton = () => (
  <section className="py-12 px-4 md:px-8">
    <div className="max-w-xl mx-auto text-center space-y-4">
      <Skeleton className="h-6 w-48 mx-auto" />
      <Skeleton className="h-4 w-72 mx-auto" />
      <Skeleton className="h-10 w-full max-w-sm mx-auto rounded-md" />
    </div>
  </section>
);
